import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { completeTask } from "./schema/complete-task";
import { getInboundShipmentMetrics } from "./schema/get-inbound-shipment-metrics";
import {
  getInventoryItems,
  getInventoryItemsForExport,
} from "./schema/get-inventory-items";
import { getInventoryMetrics } from "./schema/get-inventory-metrics";
import { getLatestRefulfillmentOrders } from "./schema/get-latest-refulfillment-orders";
import { getManagedReturnsMetrics } from "./schema/get-managed-returns-metrics";
import { getRecentReturns } from "./schema/get-recent-returns";
import { getRefulfillmentMetrics } from "./schema/get-refulfillment-metrics";
import {
  getReturnNetworkProducts,
  getReturnNetworkProductsForExport,
} from "./schema/get-return-network-products";
import { getReturnsCenters } from "./schema/get-returns-centers";
import { getTasks } from "./schema/get-tasks";
import { getTasksMetrics } from "./schema/get-tasks-metrics";
import { listInboundConsolidatedShipments } from "./schema/list-inbound-consolidated-shipments";
import { listManufacturers } from "./schema/list-manufacturers";
import {
  getManagedReturnsIntegrations,
  getManagedReturnsIntegrationSettings,
  updateManagedReturnsIntegrationSettings,
} from "./schema/managed-returns-integrations";
import {
  createProductMapping,
  deleteProductMapping,
  listProductMappings,
  searchProductsForMapping,
} from "./schema/product-mappings";
import { updateReturnNetworkProductVariant } from "./schema/update-return-network-product-variant";
import { updateReturnsCenter } from "./schema/update-returns-center";

export const rpcDefinition = {
  completeTask,
  getInboundShipmentMetrics,
  getInventoryItems,
  getInventoryItemsForExport,
  getInventoryMetrics,
  getLatestRefulfillmentOrders,
  getManagedReturnsIntegrations,
  getManagedReturnsIntegrationSettings,
  updateManagedReturnsIntegrationSettings,
  getManagedReturnsMetrics,
  getRecentReturns,
  getRefulfillmentMetrics,
  getReturnNetworkProducts,
  getReturnNetworkProductsForExport,
  getTasks,
  getTasksMetrics,
  listInboundConsolidatedShipments,
  getReturnsCenters,
  updateReturnsCenter,
  listProductMappings,
  searchProductsForMapping,
  createProductMapping,
  deleteProductMapping,
  listManufacturers,
  updateReturnNetworkProductVariant,
};

export type RedoManagedReturnsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
